import styled from 'styled-components';
import { colors } from 'constants/colors';
import { BasicSectionContainer } from '../../style';
import {
  bookingStepContainerStyles,
  bookingStepContentStyles,
  roomSelectionMobileStyles,
} from '../../bookingStepStyles';
import { sectionBackgroundStyles } from 'screens/sectionBackgroundStyles';
// import noRoomsPicture from 'assets/images/noRoomsAvailable.png';

export const RoomOptionsContentContainer = styled(BasicSectionContainer)`

  ${bookingStepContainerStyles}

  .optionCardTitle {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 32px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 5px;
    }

    .description {
      display: flex;
      align-items: center;
      height: 36px;
      font-weight: bold;
      background-color: ${colors.optionBackground};
      padding: 7px 10px;

      svg {
        position: relative;
        /* width: 21px;
        height: 21px; */
        margin-right: 8px;
      }

      span {
        color: ${colors.white};
        font-size: 14px;
        line-height: 21px;
        height: 21px;
      }
    }
  }


  /* @media only screen and (max-width: 1200px) {
    .optionCardTitle {
      flex-direction: column;
      margin-bottom: 10px;

      .title {
        width: 100%;
      }

      .description {
        width: calc( 100% + 40px);
        padding: 7px 20px;
      }
    }


  } */

  .background {
    ${sectionBackgroundStyles}
  }

  .content {
    ${bookingStepContentStyles}
    column-gap: 32px;
  }

  ${roomSelectionMobileStyles}
`;
// Moved to common css ../../styles
// export const RoomOptionsContainer = styled(BasicSectionContainer)`
//   flex-basis: 60%;
//   max-width: 800px;
//   display: flex;
//   flex-direction: column;
//   justify-content: flex-start;
//   margin: 45px 0 50px 0;

//   .noRoomsTitle {
//     font-size: 33px;
//     color: ${colors.red};
//     margin: 20px 0 0 0;
//   }

//   .noRoomsPicture {
//     width: 100%;
//     height: 447px;
//     background-size: contain;
//     background-position: left top;
//     background-repeat: no-repeat;
//     background-image: url(${noRoomsPicture});
//     margin: 20px 0 50px 0;

//     @media only screen and (max-width: 767px) {
//       height: auto;
//       background-position: center;
//     }
//   }

//   .roomOptionsTitle {
//     font-size: 34px;
//     font-weight: 600;
//     margin-bottom: 20px;
//   }

//   @media only screen and (max-width: 1200px) {
//     width: 100%;
//     max-width: 100%;
//   }
// `;


// Now Loaded from common 'components/OptionCard/style';
// export const OptionCardContainer = styled.div<{selected?: boolean}>`
//   display: flex;
//   padding: 5px;
//   flex-direction: column;
//   cursor: pointer;

//   @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
//     padding: 0;
//   }


//   .optionCardTitle {
//     font-size: 20px;
//     font-weight: bold;
//     margin-bottom: 5px;
//     @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
//       flex-direction: column-reverse;
//       gap: 16px;
//     }
//   }


//   .title {
//       font-size: 20px;
//       font-weight: bold;
//       margin-bottom: 5px;
//       @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
//         align-self: flex-start;
//       }
//     }

//     .description {
//       display: flex;
//       align-items: center;
//       height: 36px;
//       font-weight: bold;
//       background-color: ${colors.optionBackground};
//       padding: 7px 10px;
//       @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
//         align-self: flex-end;
//         margin-right: -16px;
//       }
//       svg {
//         position: relative;
//         /* width: 21px;
//         height: 21px; */
//         margin-right: 8px;
//       }

//       span {
//         color: ${colors.white};
//         font-size: 14px;
//         line-height: 21px;
//         height: 21px;
//       }
//     }
//   }



  
//   .optionCardAttributes {
//     display: flex;
//     justify-content: flex-start;
//     width: 100%;
//     flex-wrap: wrap;
//     padding: 24px 0 16px 0;
//     gap: 19px;

//     .roomAttributeCross {
//       color: ${colors.red};
//     }

//     .roomAttribute {
//       //margin: 0 12px 0 0;
//       display: flex;
//       flex-direction: row;
//       align-items: center;
//       font-size: 16px;
      

//       svg {
//         position: relative;
//         width: 14px;
//         height: 14px;
//         margin-right: 8px;
//         top: 0;
//       }
//     }
//   }

//   .windowsOption {
//     display: flex;
//     justify-content: flex-start;
//     align-items: center;
//     border: ${({selected}) => selected? `1px solid ${colors.optionBackground}`: `1px solid ${colors.signInBorderColor}`};
//     padding: 11px 0;
//     margin: 15px 0;

//     .customizedRadio {
//       position: relative;
//       width: 21px;
//       height: 21px;
//       border-radius: 50%;
//       border: 2px solid ${colors.signInBorderColor};
//       margin: 0 10px;

//       ${({selected}) => selected? `
//         ::before {
//           content: '';
//           position: absolute;
//           left:3px;
//           top: 3px;
//           width: 11px;
//           height: 11px;
//           background-color: ${colors.optionBackground};
//           border-radius: 50%;
//         }
//       `: null};
//     }

//     .optionDescription {
//       font-size: 16px;
//       font-weight: 600;
//       margin-right: 10px;
//     }

//     .explanation {
//       font-size: 14px;
//       color: ${colors.textInputLabel};
//     }
//   }
// `;


// Moved to common css ../../styles
// export const BookingSummaryContainer = styled.div`
//   flex-basis: 40%;
//   min-width: 400px;
//   margin: 103px 0 0 0;
//   .editTrip {
//       cursor: pointer;
//       align-items: center;
//       font-size: 15px;
//       font-weight: 400;
//       color: ${colors.hoverBlue};
//       text-decoration: underline;
//     }

//   .controls {
//     display: flex;
//     flex-direction: row;
//     justify-content: flex-end;
//     width: 100%;
//   }

//   .title {
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     margin-top: 10px;


//     .text {
//       font-size: 24px;
//       font-weight: 600;

//     }

//   }

//   .booking {
//     font-size: 18px;
//     margin: 38px 0 24px 0;
//     font-weight: 600;
//   }
//   .bookingDates {
//     .text {
//       font-size: 14px;
//       font-weight: 600;
//       margin-bottom: 5px;
//     }

//     .checkInOutDates {
//       font-size: 18px;
//     }
//   }

//   .guestOption, .roomOption {
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     margin: 10px 0;
//     padding: 5px 0;
//     border-bottom: 1px solid ${colors.checkOutTableTextColor};

//     .text {
//       font-size: 14px;
//       font-weight: 600;
//     }

//     .numbers {
//       font-size: 21px;
//       font-weight: 600;
//     }

//     .remove {
//       cursor: pointer;

//       .removeIcon {
//         margin: 11px 0 4px 5px;
//         height: 12px;
//         width: 12px;
//       }
//     }
//   }

//   .datesTable {
//     margin-top: 32px;
//     width: 100%;
//     .hdr {
//       white-space: nowrap;
//       padding-bottom: 15px;
//       font-weight: 600;
//       font-size: 16px;
//     }
//     .data {
//       font-size: 16px;
//     }
//     .dataRt {
//       text-align: right;
//     }
//   }
//   .breakdownTable {
//   padding-top: 10px;
//   font-size: 16px;
//   width: 100%;

//   td {
//     padding-bottom: 15px;
//   }

//   .line {
//     display: flex;
//     align-items: center;
//     justify-content: space-between;
//     white-space: nowrap;
//   }

//   .label {
//     padding-right: 10px;
//   }

//   .dots {
//     flex-grow: 1;
//     border-bottom: 1px dotted #aaa;
//     margin: 0 10px;
//     height: 1px;
//     transform: translateY(-1px);
//   }
//   .price {
//     text-align: right;
//     white-space: nowrap;
//   }

//   .total {
//     font-weight: bold;
//   }
// }

//   .priceDetails {
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     margin: 10px 0;
//     padding: 5px 0;
//     border-bottom: 1px solid ${colors.checkOutTableTextColor};

//     .text {
//       font-size: 14px;
//       font-weight: 600;
//     }

//     .price {
//       font-size: 18px;
//       font-weight: 600;
//     }
//   }

//   @media only screen and (max-width: 767px) {
//     /* width: 100%;
//     max-width: 100%;
//     margin: 0 0 50px 0;

//     .title {
//       text-align: center;
//     } */

//     display: none;
//   }
// `;

